import { AxiosResponse } from 'axios'
import request from '@/helpers/request'
import { DealDetails } from '@/classes/DealDetails'
import { FrontendGiveawayParticipantInfo, GiveawayEntry, GiveawayInfo } from '@/classes/Giveaways'
import { Article } from '@/classes/Articles'
import { ScrapeAmazonSearchResultsResult } from '@/classes/Search'
import TrainingDataItem from '@/classes/TrainingDataItem'

export default {
    getArticles: (pageSize: number, pageNumber: number, excludeArticleId: number, isGiftList: boolean): Promise<AxiosResponse<Article[]>> => request.get(`/GetArticles?pageSize=${pageSize}&pageNumber=${pageNumber}&excludeArticleId=${excludeArticleId}&isGiftList=${isGiftList}`),
    getArticleDetails: (articleId: number, includeDeals: boolean): Promise<AxiosResponse<Article>> => request.get(`/GetArticleDetails?articleId=${articleId}&includeDeals=${includeDeals}`),
    getLatestDeals: (pageSize: number, pageNumber: number, excludeDeal: number): Promise<AxiosResponse<DealDetails[]>> => { 
        if(excludeDeal) {
            return request.get(`/GetLatestDeals?pageSize=${pageSize}&pageNumber=${pageNumber}&excludeDeal=${excludeDeal}`);
        }
        return request.get(`/GetLatestDeals?pageSize=${pageSize}&pageNumber=${pageNumber}`);
    },
    submitContactUsForm: (form: any) => request.post('/SubmitContactUsForm', form),
    newsletterSignup: (form: any) => request.post('/NewsletterSignup', form),
    getDealsByDate: (pageSize: number, pageNumber: number, excludeDeal: number, date: string): Promise<AxiosResponse<DealDetails[]>> => request.get(`/GetDealsByDate?pageSize=${pageSize}&pageNumber=${pageNumber}&excludeDeal=${excludeDeal}&date=${date}`),
    getDeal: (dealId: number): Promise<AxiosResponse<DealDetails>> => request.get(`/GetDeal?dealId=${dealId}`),
    getGiveawayInfo: (ParticipantHash: string | null = null): Promise<AxiosResponse<GiveawayInfo>> => request.get(`/GetGiveawayInfo?ParticipantHash=${ParticipantHash}`),
    newGiveawayEntry: (newEntry: GiveawayEntry): Promise<AxiosResponse<FrontendGiveawayParticipantInfo>> => request.post('/NewGiveawayEntry', newEntry),

    ////////
    postToFacebookPage: (data: any) => request.post('/PostToFacebookPage', data),
    postToFacebookGroup: (data: any) => request.post('/PostToFacebookGroup', data),
    postToTwitter: (data: any) => request.post('/PostToTwitter', data),
    postToTwitter2: (data: any) => request.post('/PostToTwitter', data),
    postToTelegram: (data: any) => request.post('/PostToTelegram', data),
    getJCNAd: (zid: any, pid: any) => request.getExternal(`https://servedby.jewishcontentnetwork.com/servlet/view/banner/url/zone?zid=${zid}&pid=${pid}`),
    googleAccessTokens: () => request.get('/googleAccessTokens'),
    googleGetRealTimeData: (params: string, headers: any) => request.getExternal(`https://www.googleapis.com/analytics/v3/data/realtime?${params}`, headers),
    analysis: {
        searchAnalytics: (data: any) => request.post('/analysis/analytics', data),
        searchOrderHistory: (data: any) => request.post('/analysis/orderHistory', data)
    },

    getBlogHomepage: (): Promise<AxiosResponse<any>> => request.get('/BlogHomepage'),
    getBlogPosts: (): Promise<AxiosResponse<any>> => request.get('/BlogPosts'),
    getBlogPost: (slug: string): Promise<AxiosResponse<any>> => request.get(`/BlogPost?slug=${slug}`),
    getSearchSuggestions: (searchQuery: string): Promise<AxiosResponse<any>> => request.get(`/search-suggestions?query=${searchQuery}`),
    getSearchResults: (searchQuery: string, maxPrice: number, minPercentOff: number, nodes: string): Promise<AxiosResponse<ScrapeAmazonSearchResultsResult>> => request.get(`/search-results?query=${searchQuery}&price=${maxPrice}&percent=${minPercentOff}&nodes=${nodes}`),
    getOutletItems: (): Promise<AxiosResponse<any>> => request.get('/GetOutletItems'),
    
    getPosts: (pageSize: number, searchText: string, status: string): Promise<AxiosResponse<any>> => request.get(`/GetPosts?pageSize=${pageSize}&searchText=${searchText}&status=${status}`),
    headerRequest: (url: string) => request.headRequest(url),

    ////////
    getModels: (): Promise<AxiosResponse<any>> => request.getExternal('http://localhost:5000/get-models', {
        'Access-Control-Allow-Origin': '*',
    }),
    guess: (modelName: string, text: string): Promise<AxiosResponse<any>> => request.postExternal('http://localhost:5000/execute', { modelName, text }, {
        'Access-Control-Allow-Origin': '*',
    }),
    trainSingle: (trainingDataItem: TrainingDataItem): Promise<AxiosResponse<any>> => request.postExternal('http://localhost:5000/train-single', trainingDataItem, {
        'Access-Control-Allow-Origin': '*',
    }),
}